/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Clear_SelectionInputs */

const en_applicants_bulk_clear_selection = /** @type {(inputs: Applicants_Bulk_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const de_applicants_bulk_clear_selection = /** @type {(inputs: Applicants_Bulk_Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl aufheben`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Applicants_Bulk_Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_clear_selection = /** @type {((inputs?: Applicants_Bulk_Clear_SelectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Clear_SelectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_clear_selection(inputs)
	return en_applicants_bulk_clear_selection(inputs)
});